module.exports = __webpack_public_path__ + "img/7.21cc3249.jpg";